import React from 'react';
import {FormattedMessage} from 'react-intl';
import {Link, ExternalLink} from 'shared-components';
import {verifyEn} from '../../../i18n/verify';
import agreement from '../assets/T&C Virtual 2022 US.pdf';

const BaseTermsLink = () => (
  <Link
    to={agreement}
    type="primary"
    target="_blank"
  >
    <FormattedMessage
      id="verify-tc-link"
      description="Link for tc"
      defaultMessage={verifyEn['verify-tc-link']}
    />
  </Link>
);

// eslint-disable-next-line react/prop-types
export default ({isError, link}) => {

  if (!link || isError) {
    return <BaseTermsLink />;
  }

  return (
    <ExternalLink
      href={link}
      target="_blank"
      rel="noopener noreferrer"
    >
      <FormattedMessage
        id="verify-tc-link"
        description="Link for tc"
        defaultMessage={verifyEn['verify-tc-link']}
      />
    </ExternalLink>
  )
  ;
};